import React, { useEffect, useState } from "react";

import DonorDetails from "../../../../components/cases/documents/healthcare-proxy/DonorDetails";
import LayoutWrapper from "../../../../common/LayoutWrapper";
import Signature from "../../../../components/cases/documents/healthcare-proxy/Signature";
import DocSwiper from "../../../../common/Swipers/DocsSwiper";
import Overview from "../../../../components/cases/documents/healthcare-proxy/Overview";
import Attorney from "../../../../components/cases/documents/healthcare-proxy/Attorney";
import AssetsManagement from "../../../../components/cases/documents/healthcare-proxy/AssetsMangement";
import MainTeleCommunication from "../../../../components/cases/documents/healthcare-proxy/MailTeleComunication";
import AdviserDocsWrapper from "../../../../common/AdviserDocsWrapper";

import { useSelector, useDispatch } from "react-redux";
import { customTab, nextTab, preTab } from "../../../../redux/slices/TabSlices";
import { getAssetsOnBoardingList } from "../../../../redux/slices/features/assetsOnBoardingSlice";
import { connect } from "react-redux";
import { resetCard } from "../../../../redux/slices/CardSlices";
import { documentSteps } from "../../../../constants/constants";
import { getHealthcareProxy } from "../../../../services/documentServices";
import {
  getDateFromDateStamp,
  getTimeFromDateStamp,
  overAllStatus,
  changeUpdateFormat,
} from "../../../../utils/Utilities";
import AuthoritiesAndMedical from "../../../../components/cases/documents/healthcare-proxy/AuthoritiesAndMedical";
import Residance from "../../../../components/cases/documents/healthcare-proxy/Residance";
import SubAuthorities from "../../../../components/cases/documents/healthcare-proxy/SubAuthorities";
import GuardianceAndAccountability from "../../../../components/cases/documents/healthcare-proxy/GuardianceAndAccountability";
import "../../../../components/yourAssets/BOA/BOA.scss";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../../common/Buttons";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { updateStatusQuoAuditTrails } from "../../../../services/auditTrails";
import ModifiedByToaster from "../../../../common/ModifiedByToaster";

const HealthcareProxy = ({
  currentTab,
  nextTab,
  preTab,
  customTab,
  resetCard,
  updates,
}) => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [steps, setSteps] = useState(documentSteps);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const handleResetCard = () => {
    resetCard();
  };
  const handleNext = () => {
    handleResetCard();
    nextTab();
  };
  const handleBack = () => {
    handleResetCard();
    preTab();
  };
  const handleCustomTab = (val) => {
    customTab(val);
  };
  const handleUpdatesTrails = async () => {
    const result = await updateStatusQuoAuditTrails(
      updates.map((item) => item.auditTrailId),
      id
    );
  };
  useEffect(() => {
    handleUpdatesTrails();
  }, [currentTab]);
  const tabMaping = {
    1: (
      <DonorDetails
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    2: (
      <Attorney
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
        buttonDisabled={buttonDisabled}
      />
    ),
    3: (
      <AssetsManagement
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    4: (
      <AuthoritiesAndMedical
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    5: (
      <Residance
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    6: (
      <MainTeleCommunication
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    7: (
      <SubAuthorities
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    8: (
      <GuardianceAndAccountability
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    9: (
      <Signature
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    10: (
      <Overview
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
  };
  const dispatch = useDispatch();
  const tabStatuses = useSelector(
    (state) => state.assetsOnBoarding.assetsSuggestionBoxText
  );

  async function fetchData() {
    const arr = [];
    const result = await getHealthcareProxy(id);
    if (result?.success && result?.payLoad) {
      const {
        donorDetail,
        replacementAttorney,
        checkListTab1,
        checkListTab2,
        checkListTab3,
        checkListTab4,
        checkListTab5,
        healthEmergencyStepStatus,
      } = result.payLoad;
      const array = [
        donorDetail?.stepStatus,
        replacementAttorney?.stepStatus,
        checkListTab1,
        checkListTab2,
        checkListTab3,
        checkListTab4,
        checkListTab5,
        healthEmergencyStepStatus,
        2,
        2,
      ];

      steps.forEach((elem, index) => {
        if (index !== steps.length - 1) {
          arr.push({ ...elem, stepStatus: array[index] });
        }
        if (index === steps.length - 1) {
          const res = overAllStatus(array);
          arr.push({ ...elem, stepStatus: res ? 2 : 1 });
        }
      });

      setSteps(arr);
    }
  }
  useEffect(() => {
    fetchData();
  }, [currentTab]);
  useEffect(() => {
    dispatch(getAssetsOnBoardingList());
  }, []);

  const renderTab = () => {
    return (
      <>
        {tabMaping[currentTab]}
        {updates.length > 0 && (
          <ModifiedByToaster
            title={`${t("modified-by")} ${updates[0]?.username}` || ""}
            subTitle={` ${changeUpdateFormat(
              updates[0]?.updatedTime,
              i18n.language
            )}`}
          />
        )}
      </>
    );
  };
  return (
    <>
      <AdviserDocsWrapper>
        <LayoutWrapper
          minHeight="calc(100vh - 120px) !important"
          borderShadow={true}
        >
          <DocSwiper
            tab={currentTab}
            back={handleBack}
            custom={handleCustomTab}
            list={steps}
            barWidth="73px"
          />
          {renderTab()}

          {currentTab !== 2 && (
            <>
              {currentTab < 9 ? (
                <div
                  style={{
                    minWidth: "310px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <SecondaryButton
                    title={t("save-and-continue")}
                    bgColor="#E8D7E5"
                    borderRadius="14px"
                    width="180px"
                    marginLeft="20px"
                    border="none"
                    hoverBgColor="color.magentaLight1"
                    textTransform="initial"
                    padding="0rem"
                    height="2.7rem"
                    form="form_submit"
                    type="submit"
                    disabled={buttonDisabled}
                  />

                  <LinkButton
                    title={t("skip-for-now")}
                    bgColor="color.transparent"
                    borderRadius="14px"
                    fontSize="0.8rem"
                    width="100px"
                    marginLeft="10px"
                    padding="0"
                    border="none"
                    click={handleNext}
                    textTransform="initial"
                  />
                </div>
              ) : (
                <div
                  className="button-container-2"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <PrimaryButton
                    title={t("save")}
                    bgColor="#E8D7E5"
                    color="#444561"
                    padding="10px 60px"
                    textTransform="initial"
                    borderRadius={"18px"}
                    boxShadow={0}
                    form="form_submit"
                    type="submit"
                  />
                </div>
              )}
            </>
          )}
        </LayoutWrapper>
      </AdviserDocsWrapper>
    </>
  );
};

function mapStateToProps(state) {
  return {
    currentTab: state.currentTab.currentTab,
    updates: state.statusQuoDocuments.updates.healthcare,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    nextTab: () => dispatch(nextTab()),
    preTab: () => dispatch(preTab()),
    customTab: (num) => dispatch(customTab(num)),
    resetCard: () => dispatch(resetCard()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HealthcareProxy);
